import(/* webpackMode: "eager" */ "/codebuild/output/src1867953891/src/apps/jumplab/src/app/error.tsx");
